import { TourId, TourStep } from "../store/useTourStore";

export const TOUR_CONFIGS: Record<TourId, TourStep[]> = {
  casePage: [
    {
      id: "launch-sky",
      target: '[data-tour="launch-sky"]',
      titleKey: "onboarding.launchSky.title",
      textKey: "onboarding.launchSky.text",
      position: "left",
      advanceOnTargetClick: true,
    },
  ],
  skyView: [
    {
      id: "doc-list",
      target: '[data-tour="doc-list"]',
      titleKey: "onboarding.docList.title",
      textKey: "onboarding.docList.text",
      position: "right",
    },
    {
      id: "ai-sidebar",
      target: '[data-tour="ai-sidebar"]',
      titleKey: "onboarding.aiSidebar.title",
      textKey: "onboarding.aiSidebar.text",
      position: "left",
      tooltipAlign: "start",
      arrowOffset: 24,
    },
  ],
};

export const getTourSteps = (tourId: TourId): TourStep[] => {
  return TOUR_CONFIGS[tourId] || [];
};
